import { useSyncExternalStore } from 'react';

/**
 * Whether the server has SAID the audit feature is off (spec 008, FR-AL01, US2 scenario 3).
 *
 * The sidebar owns the one live Alerts query and learns this from its 503; the header bell reads it
 * here. ⚠ The bell cannot learn it for itself: an error is never stored, so a passive read sees "no
 * copy" for both "switched off" and "not loaded yet", and asking the server per page is exactly what
 * FR-AL04 forbids. Same rule as the Audit entry: only an explicit `AUDIT_DISABLED` dims — loading or
 * an upstream failure stays live.
 */
let off = false;
const listeners = new Set<() => void>();

export function setAlertsSwitchedOff(value: boolean): void {
  if (value === off) return;
  off = value;
  for (const l of listeners) l();
}

export function useAlertsSwitchedOff(): boolean {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => off,
  );
}
